/**
 * Labstep
 *
 * @module components/Entity/Action/Update/SearchSelect
 * @desc Entity Update action with SearchSelect
 */

import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { callIf } from 'labstep-web/services/react.service';
import type React from 'react';
import type { EntityActionUpdateSearchSelectProps } from './types';

export const EntityActionUpdateSearchSelect: React.FC<
  EntityActionUpdateSearchSelectProps
> = ({ entity, getBody, options, optimistic, onUpdate, ...rest }) => (
  <EntityUpdateContainer
    entityName={entity.entityName}
    id={entity.idAttr}
    optimistic={optimistic}
  >
    {({ update }): React.ReactElement => (
      <ParamsStateContextProvider value={{}}>
        <SearchSelect
          onChange={(value): void => {
            update(getBody(value), options);
            callIf(onUpdate, value);
          }}
          {...rest}
        />
      </ParamsStateContextProvider>
    )}
  </EntityUpdateContainer>
);
